var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8V6.33356L10.9149 1.41869L12.5813 3.08513L7.66644 8H6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.87 1.16984C14.0433 1.34315 14.0433 1.62311 13.87 1.79642L13.0568 2.60964L11.3904 0.943202L12.2036 0.129982C12.3769 -0.0433273 12.6569 -0.0433273 12.8302 0.129982L13.87 1.16984Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17241 1.44827C1.77248 1.44827 1.44828 1.77249 1.44828 2.17243V11.8276C1.44828 12.2275 1.77248 12.5517 2.17241 12.5517H11.8276C12.2275 12.5517 12.5517 12.2275 12.5517 11.8276V6.96552C12.5517 6.56558 12.8759 6.24139 13.2759 6.24139C13.6758 6.24139 14 6.56558 14 6.96552V11.8276C14 13.0274 13.0274 14 11.8276 14H2.17241C0.972624 14 0 13.0274 0 11.8276V2.17243C0 0.972626 0.972622 7.17486e-07 2.17241 7.17486e-07H7.03448C7.43441 7.17486e-07 7.75862 0.324219 7.75862 0.724152C7.75862 1.12405 7.43441 1.44827 7.03448 1.44827H2.17241Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.0e220228477a8c3707eb8ce1f207146a.svg";
export { ForwardRef as ReactComponent };